<template>
  <div class="WarningMessage">
    <div v-if="vif" class="p-2 d-flex flex-column text-center w-100 mt-3">
      <label class="alert alert-warning" v-text="vtext"> </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "WarningMessage",
  props: {
    vif: {
      type: Boolean,
      required: true,
      default: false,
    },
    vtext: {
      required: true,
      default: "",
    },
  },
};
</script>
